<template>

        <div class="chat-component">
            <div v-if="isOpen" class="chat-container">
                <div class="chat-header">
                    <h3>
                        <i class="icon-base bs-chat-ia" />
                        Base Innovation
                    </h3>
                    <button @click="toggleChat">&times;</button>
                </div>
                <div class="chat-messages" ref="messagesContainer">
                    <div v-for="(message, index) in messages" :key="index" :class="['message', message.sender]">
                        <p>{{ message.text }}</p>
                    </div>
                </div>
                <div class="chat-input">
                    <input type="text" :readonly="loading" v-model="prompt" @keypress.enter="sendMessage" placeholder="Digite sua mensagem...">
                    <button @click="sendMessage" :disabled="loading">Enviar</button>
                </div>
            </div>
            <button v-else @click="toggleChat" class="chat-button">
                <i class="icon-base bs-chat-ia" />
            </button>
        </div>
</template>

<script>
export default {
    name: 'Chat',
    data: function() {
        return {
            isOpen: false,
            loading: false,
            messages: [
                // {"text": "Olá", "sender": "user"},
                // {"text": "Olá, em que posso ajudar?", "sender": "agent"},
            ],
            prompt: ''
        };
    },
    methods: {
        toggleChat: function() {
            this.isOpen = !this.isOpen;
        },
        sendMessage: function() {
            let self = this;
            if (this.prompt.trim() !== '') {

                self.loading = true;
                self.messages.push({
                    text: self.prompt,
                    sender: 'user'
                });                
                self.$nextTick(() => {
                    self.scrollToEnd();
                });
                axios.post("api/openai.php", {prompt: self.prompt}, {authentication: true})
                .then(response => {
                    
                    console.log("sendMessage() response", response.data.result)
                    self.loading = false;
                    
                    response.data.result.choices.forEach(function(item) {
                        self.messages.push({
                            text: item.message.content,
                            sender: 'agent'
                        });
                    });

                    self.prompt = '';
                    self.$nextTick(() => {
                        self.scrollToEnd();
                    });
                })
                .catch(error => {
                    console.log("sendMessage() error", error);
                    self.loading = false;
                    self.messages.push({
                        text: 'Erro ao processar mensagem, por favor, tente novamente.',
                        sender: 'agent'
                    });                    
                });
            }
        },
        scrollToEnd: function() {
            const container = this.$refs.messagesContainer;
            container.scrollTop = container.scrollHeight;
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped="">
 .chat-container {
    /* display: none; */
    position: fixed;
    bottom: 0;
    right: 20px;
    width: 500px;
    max-width: 100%;
    max-height: 700px;
    color: var(--theme-color-primary);
    border: 1px solid #ccc;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
    background-color: #fff;
    border-radius: 10px 10px 0 0;
    overflow: hidden;
    z-index: 1000;
}

.chat-header {
    background-color: var(--theme-color-primary);
    color: #fff;
    padding: 10px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-radius: 10px 10px 0 0;
}

.chat-header h3 {
    margin: 0;
    color: #fff;
    font-size: 16px;
}
.chat-header h3 i {
    top: 4px;
    background: #ffffff;
    line-height: 0;
    width: 20px;
    height: 20px;
    mask-size: 20px;
    /* margin-top: 2px;     */
}
.chat-header button {
    background: none;
    border: none;
    color: #fff;
    font-size: 20px;
    cursor: pointer;
    margin-top: -2px;
}

.chat-messages {
    padding: 10px;
    height: 450px;
    overflow-y: auto;
}

.message {
    display: flex;
    margin-bottom: 10px;
}

.message.user {
    justify-content: flex-end;
}

.message p {
    max-width: 60%;
    padding: 10px;
    border-radius: 5px;
    margin: 0;
    word-break: break-word;
    max-width: 100%;
    white-space: pre-wrap;
}

.message.user p {
    background-color: var(--theme-color-light);
    color: #fff;
    border-bottom-right-radius: 0;
}

.message.agent p {
    background-color: #f1f1f1;
    color: #000;
    border-bottom-left-radius: 0;
}

.chat-input {
    display: flex;
    border-top: 1px solid #ccc;
    padding: 10px;
}

.chat-input input {
    flex: 1;
    margin-bottom: 0px;
    padding: 10px;
    border: 1px solid #ccc;
    border-radius: 5px;
    margin-right: 10px;
}

.chat-input button {
    padding: 10px 20px;
    border: none;
    background-color: var(--theme-color-light);
    color: #fff;
    border-radius: 5px;
    cursor: pointer;
    height: 40px;
}

.chat-button {
    position: fixed;
    bottom: 10px;
    right: 20px;
    /* padding: 10px 20px; */
    height: 50px;
    width: 50px;
    background-color: var(--theme-color-primary);
    color: #fff;
    border: none;
    border-radius: 50px;
    cursor: pointer;
    z-index: 1000;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
    font-size: 16px;
    display: flex;
    gap: 6px;
    align-items: center;
    justify-content: center;
}

.chat-button i {
    background: #ffffff;
    line-height: 0;
    width: 30px;
    height: 30px;
    mask-size: 30px;
    margin-top: -1px;
}

@media only screen and (max-width: 500px) { 
    .chat-container {
        width: 100% !important;
        right: 0px;
        left: 0px;
        /* height: 100%; */
    }
    .chat-messages {
        height: 500px;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/Chat.vue